import React, { type ReactNode } from "react";
import { Flex } from "@chakra-ui/react";

export function KeyFooter({ children }: { children: ReactNode }) {
  return (
    <Flex align="center" fontWeight="medium" mt={1}>
      {children}
    </Flex>
  );
}
